import { TriangleAlert } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import type { Channel } from '@/types/channel';

export interface DisconnectedChannelActionsProps {
  channel: Channel;
  onReconnect: () => void;
  reconnecting: boolean;
}

/**
 * Disconnected-state surface. Destructive (error) alert + Reconnect only. Per
 * the "Channel Disconnect (not Remove)" design (2026-06-27), there is NO
 * user-facing Remove: a disconnected channel is retained as history and the
 * only action is to reconnect it in place (Instagram routes to its existing
 * connect flow via the parent's onReconnect). Physical deletion is a separate
 * admin/GDPR path, not surfaced here.
 */
export function DisconnectedChannelActions({
  onReconnect,
  reconnecting,
}: DisconnectedChannelActionsProps) {
  return (
    <Alert variant="destructive">
      <TriangleAlert className="size-4" />
      <AlertTitle>This channel is disconnected from Meta</AlertTitle>
      <AlertDescription className="space-y-3">
        <p>Reconnect to restore messaging on this channel.</p>
        <div className="flex flex-wrap gap-2">
          <Button size="sm" onClick={onReconnect} disabled={reconnecting}>
            {reconnecting ? 'Reconnecting...' : 'Reconnect'}
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );
}
